import { AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh'
import { TransformNode } from '@babylonjs/core/Meshes/transformNode'
import Part from './Part'

export default class Clip extends Part {
	public TempleOut: TransformNode

	constructor(parent: TransformNode = null, mirror: boolean = false) {
		super('CLIP', parent, mirror)

		this.TempleOut = new TransformNode('TEMPLE-OUT', this.getScene())
		this.attachmentPoints.set('TEMPLE-OUT', this.TempleOut)

		this.TempleOut.parent = this
	}

	override get filename(): string {
		if (this.config.components.CLIP) {
			return `Clips/${this.isPrecious ? 'Precious' : 'Titanium'}/${[this.config.components.CLIP.design, this.config.components.CLIP.size].filter(Boolean).join(' ')}`
		} else {
			return null
		}
	}

	override get isPrecious(): boolean {
		return this.config.components.CLIP?.color?.startsWith('AU750') || this.config.components.CLIP?.color?.startsWith('PT950')
	}

	override getMeshMaterialName(mesh: AbstractMesh): string {
		if (mesh.name == 'WIRE' || mesh.name == 'CLIP') {
			return this.config.components.CLIP.color
		} else {
			throw (`Unexpected ${this.name} mesh: (${mesh.name})`)
		}
	}

	// override swap(animated?: boolean) {
	//     super.swap(animated)
	//     // if (this.config.components.CLIP?.color) {
	//     //     this.getChildMeshes(true).filter(x => x.name.includes("TITANIUM") || x.name.includes("WIRE") || x.name.includes("PLATE")).forEach(clip => {
	//     //         clip.material = this.getScene().getMaterialByName(this.config.components.CLIP.color)
	//     //     })
	//     // }
	//     this.getComponentMeshes("WIRE", ).flat().forEach(mesh => this.assignMaterial(mesh, this.config.components["CLIP"]?.color))
	// }
}
